import { render } from "./CatGrupoMaterialForm.vue?vue&type=template&id=ac550626&scoped=true"
import script from "./CatGrupoMaterialForm.vue?vue&type=script&lang=js"
export * from "./CatGrupoMaterialForm.vue?vue&type=script&lang=js"

import "./CatGrupoMaterialForm.vue?vue&type=style&index=0&id=ac550626&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac550626"]])

export default __exports__